import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    HardDeleteContact as HardDeleteContactMutation,
    HardDeleteContactVariables,
} from 'nutshell-graphql-types';

import HARD_DELETE_CONTACT from '../mutations/hard-delete-contact.graphql';

export const useHardDeleteContact = (): {
    hardDeleteContact: (contactId: string) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [hardDeleteContact, {loading, error}] = useMutation<
        HardDeleteContactMutation,
        HardDeleteContactVariables
    >(HARD_DELETE_CONTACT);

    return {
        hardDeleteContact: (contactId: string) => hardDeleteContact({variables: {contactId}}),
        isLoading: loading,
        // @ts-expect-error
        error: error && safelyGetGraphQLErrorMessage(error),
    };
};
